import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  LoggingService,
  ExpirationTimePeriod,
} from "app/shared";
import { BaseDetailsLogic } from "app/analytics/BaseDetailsLogic";
import { UsersCurrentConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { TooltipCoordinatorService } from "app/analytics/services/tooltip-coordinator.service";

@Component({
  selector: "users-current-details",
  templateUrl: "./users-current-details.component.html",
  standalone: false,
})
export class UsersCurrentDetailsComponent
  extends BaseDetailsLogic<UsersCurrentConfig>
  implements OnInit, OnDestroy
{
  constructor(
    analyticsService: AnalyticsService,
    authService: AuthorizationService,
    loggingService: LoggingService,
    tooltipCoordinator: TooltipCoordinatorService
  ) {
    super(analyticsService, authService, loggingService, UsersCurrentConfig, tooltipCoordinator);
  }

  get selectedExpirationTimePeriod(): string | ExpirationTimePeriod {
    return this.config?.expirationPeriod as ExpirationTimePeriod;
  }

  set selectedExpirationTimePeriod(value: string | ExpirationTimePeriod) {
    this.config.expirationPeriod = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }

  protected getInfoTexts(): { [key: string]: string } {
    return {
      expirationTimePeriod: "Choose how long a session should last before it is considered expired. For example, if you select '30 minutes', any session that has not been active for 30 minutes will be considered ended. This helps you see which sessions are currently active."
    };
  }
}
